import React from 'react';
import { useTranslation } from 'react-i18next';
import { components } from 'react-select';

import { ReactComponent as PlusIcon } from '../../../../../../assets/images/plus-normal.svg';

import styles from '../Mapping.module.scss';

const CustomMenuList = ({ children, ...restProps }) => {
  const { t } = useTranslation('common');
  return (
    <components.MenuList {...restProps}>
      <div className={styles.menuListCont}>
        <div className={styles.optionsCont}>{children}</div>
        <div
          className={styles.customFieldCont}
          onClick={restProps.selectProps.handleAddCustomField}
          role="presentation"
        >
          <PlusIcon />
          <p className={styles.customText}>{t('customField')}</p>
        </div>
      </div>
    </components.MenuList>
  );
};

export default CustomMenuList;
